import { NavLink } from 'react-router-dom';
import logo from 'assets/images/logo/bitsweep.svg';
import logoWithText from 'assets/images/logo/bitsweep.svg';

const Logo = ({ withText = false, width = '150px' }) => {
  return (
    <NavLink
      to={'/'}
      style={{
        width,
        lineHeight: 0,
        '& img': { objectFit: 'contain', objectPosition: 'center' },
        height: 195,
        marginTop: '2rem'
      }}
    >
      <img
        src={withText ? logo : logoWithText}
        alt='Bit Sweep'
        width='100%'
        height='100%'
      />
    </NavLink>
  );
};

export default Logo;
